import React from 'react'
import { useDebouncer } from './use-debouncer'

export function useDebouncedValue<T> (value: T, interval: number) {
  const [debouncedValue, setDebouncedValue] = React.useState(value)
  const debouncer = useDebouncer(interval)
  
  React.useEffect(() => {
    debouncer(() => setDebouncedValue(value))
  }, [debouncer, value])

  return debouncedValue
}
